module.exports = __webpack_public_path__ + "img/weapon15.png";